if (!customElements.get('section-cart-drawer')) {
  class TG_SectionCartDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.element = this;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.documentDelegate = new themegoal.libs.Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.itemCount = this.options['itemCount'];

      this.showCrossSell = this.options['showCrossSell'];
      this.firstItemProductId = this.options['firstItemProductId'];
      this.preFirstItemProductId = '0';
  
      this.sidebarDrawer = new themegoal.components.Drawer(this);
      this.element.addEventListener('hidden.tg.Drawer', this._onDrawerClosed.bind(this));
  
      this._bindEventsListeners();
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      if(this.documentDelegate)this.documentDelegate.destroy();
      if(this.sidebarDrawer)this.sidebarDrawer.hide();
    }
  
    _bindEventsListeners() {
      this.delegateElement.on('change', '#CartNote', this._updateCartNote.bind(this));
      this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
      this.delegateElement.on('change', '.CartItem__QuantityNum', this._updateItemQuantity.bind(this));
  
      document.addEventListener('product:added', this._onProductAdded.bind(this));
  
      this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));

      this.delegateElement.on('click', '#CartDiscount__Apply', this._applyDiscount.bind(this));
      this.delegateElement.on('click', '.CartDiscount__Remove', this._removeDiscount.bind(this));
    }

    _loadRecommendationsComplementary() {
      var _this = this;

      if(this.itemCount < 1){
        this.element.querySelector('.CartDrawerCrossSell').style.display = 'none';
        this.firstItemProductId = '0'
        this.preFirstItemProductId = '0'
      };
  
      if (this.firstItemProductId=='0' || _this.preFirstItemProductId == _this.firstItemProductId) return;

      var url = window.routes.productRecommendationsUrl + '?section_id=cart-drawer-cross-sell&intent=complementary&product_id=' + this.firstItemProductId + '&limit=' + this.options['recommendationsComplementaryCount'];
  
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;

          let recommendationsElement = _this.element.querySelector('.CartDrawerCrossSell .CartDrawerCrossSell__Body');
          let cartDrawerCrossSellHiddenFromsrecommendationsElement = _this.element.querySelector('.CartDrawerCrossSellHiddenFroms');

          if(container.querySelector('.Carousel__Item')){
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".CartDrawerCrossSell__Body").innerHTML;
            cartDrawerCrossSellHiddenFromsrecommendationsElement.innerHTML = container.querySelector(".CartDrawerCrossSellHiddenFroms").innerHTML;
            new themegoal.components.Carousel(recommendationsElement.querySelector('[data-carousel-config]'));
            _this.element.querySelector('.CartDrawerCrossSell').style.display = 'block';
          }else{
            _this.element.querySelector('.CartDrawerCrossSell').style.display = 'none';
          }

          _this.preFirstItemProductId = _this.firstItemProductId;
  
        });
      });
    }
  
    _updateCartNote(event, target) {
      fetch(window.routes.cartUrl + '/update.js', {
        body: JSON.stringify({ note: target.value }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      });
    }
  
    _updateItemQuantity(event, target) {
      var _this = this;
  
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
      var quantity = null,
          elementToAnimate = null;
  
      if (target.tagName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        //+ - button
        quantity = parseInt(target.getAttribute('data-quantity'));
      }
  
      if (quantity === 0) {
        elementToAnimate = target.closest('.CartItem__Wrapper');
      }
  
      fetch(window.routes.cartChangeUrl + '.js', {
        body: JSON.stringify({ id: target.getAttribute('data-line-id'), quantity: quantity }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      }).then(function (cart) {
        cart.json().then(function (content) {
          _this.itemCount = content['item_count'];
          _this._rerenderCart(elementToAnimate);
  
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      });
  
      event.preventDefault();
    }
  
    _onProductAdded(event) {
      var _this = this;
  
      this.itemCount += event.detail.quantity;
  
      this._rerenderCart().then(function () {
        _this.sidebarDrawer.show();
      });
    }
  
    _onDrawerClosed() {
      let cartDrawerNoteElement = document.getElementById('CartDrawerNoteCollapse');
      if(cartDrawerNoteElement){
        let cartDrawerNoteCollapse = new themegoal.components.Collapse(cartDrawerNoteElement, { toggle: false });
        cartDrawerNoteCollapse.hide();
      }

      let cartDrawerDiscountCodeElement = document.getElementById('CartDrawerDiscountCodeCollapse');
      if(cartDrawerDiscountCodeElement){
        let cartDrawerDiscountCodeCollapse = new themegoal.components.Collapse(cartDrawerDiscountCodeElement, { toggle: false });
        cartDrawerDiscountCodeCollapse.hide();
      }
    }
  
    _rerenderCart(elementToAnimate) {
      var _this = this;
  
      return fetch(window.routes.cartUrl + '?section_id=' + this.options['sectionId'] + '&timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (content) {
        if ( elementToAnimate ) {
          themegoal.libs.anime({
            targets: elementToAnimate,
            opacity: 0,
            height: 0,
            duration: 500,
            easing: 'easeOutCubic',
            complete: function(anim) {
              content.text().then(function (html) {
                _this._replaceContent(html);
              });
            }
          });
        } else {
          content.text().then(function (html) {
            _this._replaceContent(html);
          });
        }
      });
    }
  
    _replaceContent(html, collapseStatus = 'close') {
      let _this = this;
  
      let tempElement = document.createElement('div');
      tempElement.innerHTML = html;
  
      let cartNodeParent = this.element.querySelector('.Form--cart').parentNode;
      let cartDrawerItemsParent = this.element.querySelector('.CartDrawer__Items').parentNode;
      let cartFooterParent = this.element.querySelector('.Drawer__Footer').parentNode;
  
      let currentScrollPosition = this.element.querySelector('.Drawer__Body').scrollTop;

      cartDrawerItemsParent.replaceChild(tempElement.querySelector('.CartDrawer__Items'), this.element.querySelector('.CartDrawer__Items'));
      cartFooterParent.replaceChild(tempElement.querySelector('.Drawer__Footer'), this.element.querySelector('.Drawer__Footer'));

      this.element.querySelector('.Drawer__Body').scrollTop = currentScrollPosition;
  
      let cartResult = JSON.parse(tempElement.querySelector('.CartDrawer').getAttribute('data-section-settings'));
  
      let cartCount = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble')),
      cartText = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountText')),
      cartQuantity = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble__Count'));
  
      this.itemCount = cartResult['itemCount'];
      this.firstItemProductId = cartResult['firstItemProductId'];
  
      cartCount.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.remove('Visible'); 
        } else {
          item.classList.add('Visible');
        }
      });
  
      cartText.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.add('Visible'); 
        } else {
          item.classList.remove('Visible');
        }
      });
  
      cartQuantity.forEach(function (item) {
        item.textContent = _this.itemCount;
      });


      if(this.options["freeShippingThreshold"]){
        let freeShippingElement = cartNodeParent.querySelector(".CartDrawer__ShippingAmountNotice");
        
  
        if(freeShippingElement){
          let freshNotice = tempElement.querySelector(".CartDrawer__ShippingAmountNotice"); let cartTotalPrice = (freshNotice || freeShippingElement).getAttribute("data-cart-total-price");
          let cartCurrencySymbol = freeShippingElement.getAttribute("data-cart-currency-symbol");
  
          cartTotalPrice = parseInt(cartTotalPrice);
  
          let freeShippingAmount = Math.round(this.options["freeShippingAmount"] * (Shopify.currency.rate || 1) / 100) * 100;
  
          if(cartTotalPrice >= freeShippingAmount){
            freeShippingElement.innerHTML = this.options["freeShippingString"];
          }else{
            let freeShippingAmountString = this.options["freeShippingAmountString"];
            freeShippingAmountString = freeShippingAmountString.replace("remaining__amount", ((freeShippingAmount - cartTotalPrice)/100).toLocaleString(Shopify.currency.active === "DKK" ? "da-DK" : "sv-SE", {maximumFractionDigits: 0}) + " " + cartCurrencySymbol);
            freeShippingElement.innerHTML = freeShippingAmountString;
          }
        }
      }

      if(this.options["showAddDiscountCode"] && collapseStatus === 'open'){
        let collapseButton = document.getElementById("CartDrawerDiscountCodeCollapseButton");
        let collapseBody = document.getElementById("CartDrawerDiscountCodeCollapse");

        if(collapseButton)
          collapseButton.setAttribute("aria-expanded", true);
        if(collapseBody)
          collapseBody.classList.add("Show");
      }

      if (this.showCrossSell) {
        this._loadRecommendationsComplementary();
      }
    
    }


    _applyDiscount(event, target) {
      var _this = this;
  
      event.preventDefault();
      event.stopPropagation();

      const discountCode = this.element.querySelector('input[name="discount"]');
      if (!(discountCode instanceof HTMLInputElement)) return;

      const discountCodeValue = discountCode.value;

      const existingDiscounts = this._existingDiscounts(); 
      if (existingDiscounts.includes(discountCodeValue)) {
        discountCode.value = '';
        return;
      }

      document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
      fetch(window.routes.cartUpdateUrl + '.js', {
        body: JSON.stringify({ discount: [...existingDiscounts, discountCodeValue].join(','), sections: [_this.options['sectionId']] }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      }).then(function (cart) {
        cart.json().then(function (content) {

          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          if (
            content.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
              return discount.code === discountCodeValue && discount.applicable === false;
            })
          ) {
            discountCode.value = '';
            _this._handleDiscountError('discount_code');
            return;
          }
          const newHtml = content.sections[_this.options['sectionId']];
          const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
          const section = parsedHtml.getElementById(`shopify-section-${_this.options.sectionId}`);
          const discountCodes = section?.querySelectorAll('.CartDiscount__Label') || [];
          if (section) {
            const codes = Array.from(discountCodes)
              .map((element) => (element instanceof HTMLLIElement ? element.dataset.discountCode : null))
              .filter(Boolean);
            // Before morphing, we need to check if the shipping discount is applicable in the UI
            // we check the liquid logic compared to the cart payload to assess whether we leveraged
            // a valid shipping discount code.
            if (
              codes.length === existingDiscounts.length &&
              codes.every((/** @type {string} */ code) => existingDiscounts.includes(code)) &&
              content.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
                return discount.code === discountCodeValue && discount.applicable === true;
              })
            ) {
              _this._handleDiscountError('shipping');
              discountCode.value = '';
              return;
            }
          }

          // _this._rerenderCart(null);
          _this._replaceContent(content.sections[_this.options['sectionId']], 'open');
          
        });
      });
  
      event.preventDefault();
    }

    _removeDiscount(event, target){
      var _this = this;

      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      event.preventDefault();
      event.stopPropagation();
  
      if (
        (event instanceof KeyboardEvent && event.key !== 'Enter') ||
        !(event instanceof MouseEvent) ||
        !(event.target instanceof HTMLElement) 
      ) {
        return;
      }
  
      const codeLabel = event.target.closest('.CartDiscount__Label');
      if (!(codeLabel instanceof HTMLLIElement)) return;
  
      const discountCode = codeLabel.dataset.discountCode;
      if (!discountCode) return;
  
      const existingDiscounts = this._existingDiscounts();
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;
  
      existingDiscounts.splice(index, 1);
  
      fetch(window.routes.cartUpdateUrl + '.js', {
        body: JSON.stringify({ discount: existingDiscounts.join(','), sections: [_this.options['sectionId']] }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      }).then(function (cart) {
        cart.json().then(function (content) {
          // _this._rerenderCart(null);

          _this._replaceContent(content.sections[_this.options['sectionId']], 'open');

          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      });
  
    }

    _existingDiscounts() {
      /** @type {string[]} */
      const discountCodes = [];
      const discountLabels = this.querySelectorAll('.CartDiscount__Label');
      for (const label of discountLabels) {
        if (label instanceof HTMLLIElement && typeof label.dataset.discountCode === 'string') {
          discountCodes.push(label.dataset.discountCode);
        }
      }
  
      return discountCodes;
    }

    _handleDiscountError(type) {
      let cartDiscountError = document.getElementById("CartDiscountError");
      let cartDiscountErrorDiscountCode = document.getElementById("CartDiscountErrorDiscountCode");
      let cartDiscountErrorShipping = document.getElementById("CartDiscountErrorShipping");

      cartDiscountError.classList.remove('Hidden');

      if(type === 'discount_code' ){
        cartDiscountErrorDiscountCode.classList.remove('Hidden');
      }else{
        cartDiscountErrorShipping.classList.remove('Hidden');
      }
      
    }
        
  }
        
  customElements.define('section-cart-drawer', TG_SectionCartDrawer);
}